import { useState, useEffect } from "react";
import { Grid, Button } from "@mui/material";
import { H3, H4 } from "../../components/Typography";
import { load } from "../../constants/storage";
import { useAppDispatch } from "../../store/hooks";
import * as Models from "../../models";
import {
  updateEsign,
  getKYCStatus,
  activateKYC,
} from "../../redux/actions/KYCAction";
import { toast } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import DashboardNavbar from "../../components/DashboardNavbar";

export default function Esign() {
  const dispatch = useAppDispatch();
  const [kycStatus, setKycStatus] = useState();

  useEffect(() => {
    checkKYCStatus();
  }, [kycStatus]);
  useEffect(() => {
    window.history.pushState(null, "", window.location.pathname);
    window.addEventListener("popstate", onBackButtonEvent);
    return () => {
      window.removeEventListener("popstate", onBackButtonEvent);
    };
  }, []);

  function onBackButtonEvent(e: PopStateEvent) {
    e.preventDefault();
    window.history.pushState(null, "", window.location.pathname);
  }
  let navigate = useNavigate();

  const esignAction = async () => {
    let userDetail: any = load("userData");
    let userDetails = JSON.parse(userDetail);
    let token = load("token");
    const req: Models.ESignRequest = {
      id: userDetails.id,
      mobile: userDetails.mobile,
      partner: userDetails?.refcode,
      callback_url: process.env.REACT_APP_ESIGN_CALL_BACK_URL || "",
    };
    dispatch(updateEsign(req, `bearer ${token}`))
      .then(async (response: any) => {
        if (response?.error?.error?.status === 400) {
          toast.error(response?.error?.error?.message);
          return;
        }
        if (userDetails?.mode === "Assisted") {
          window.open(response?.fpdata?.redirect_url, "_blank");
          navigate("/dashboard");
        } else {
          window.open(response?.fpdata?.redirect_url, "_self");
        }
      })
      .catch((error: any) => {
        console.log("login__error", error);
      });
  };

  const update = () => {
    navigate("/dashboard");
  };

  const checkKYCStatus = async () => {
    let userDetail: any = load("userData");
    let userDetails = JSON.parse(userDetail);
    let token = load("token");
    const req: Models.MutualFundKYCRequestStatus = {
      id: userDetails.id,
      mobile: userDetails.mobile,
      partner: userDetails?.refcode,
    };

    dispatch(getKYCStatus(req, `bearer ${token}`))
      .then(async (response: any) => {
        if (response.statusCode === 400) {
          return;
        }
        setKycStatus(response?.data?.user_status);
      })
      .catch((error: any) => {
        toast.error(error);
      });
  };

  const proceed = async () => {
    let userDetail: any = load("userData");
    let userDetails = JSON.parse(userDetail);
    let token = load("token");
    const req: Models.MutualFundKYCRequestStatus = {
      id: userDetails.id,
      mobile: userDetails.mobile,
      partner: userDetails?.refcode,
    };
    dispatch(activateKYC(req, `bearer ${token}`))
      .then(async (response: any) => {
        navigate("/dashboard");
      })
      .catch((error: any) => {
        console.log("login__error", error);
      });
  };

  return (
    <Grid textAlign="center" justifyContent="center">
      <DashboardNavbar />
      <Grid sx={{ mt: 5 }}>
        {kycStatus === "ESIGNREQUIRED" && <H3>ESIGNREQUIRED</H3>}
        {kycStatus === "KYCPENDING" && <H3>PENDING</H3>}
        {kycStatus === "KYCREJECTED" && <H3>KYC REJECTED</H3>}
        {kycStatus === "KYCEXPIRED" && <H3>KYC EXPIRED</H3>}
        {kycStatus === "ESIGNSUBMITTED" && <H3>E-SIGN SUBMITTED</H3>}
        {kycStatus === "KYCSUBMITTED" && <H3>SUBMITTED</H3>}
        {kycStatus === "KYCAPPROVED" && <H3>SUCCESSFUL</H3>}

        {kycStatus !== "KYCREJECTED" &&
          kycStatus !== "KYCAPPROVED" &&
          kycStatus !== "KYCEXPIRED" && (
            <H4>
              {" "}
              Please wait while your bank verification is being processed
            </H4>
          )}

        {kycStatus === "KYCAPPROVED" && <H4>Your KYC has been approved.</H4>}
      </Grid>
      {kycStatus === "ESIGNREQUIRED" && (
        <Button
          onClick={() => esignAction()}
          type="submit"
          variant="contained"
          size="medium"
          sx={buttonStyle}
        >
          PROCEED TO E-SIGN
        </Button>
      )}

      {kycStatus === "KYCREJECTED" && (
        <Button
          onClick={() => update()}
          type="submit"
          variant="contained"
          size="medium"
          sx={buttonStyle}
        >
          UPDATE KYC
        </Button>
      )}

      {kycStatus === "KYCEXPIRED" && (
        <Button
          onClick={() => update()}
          type="submit"
          variant="contained"
          size="medium"
          sx={buttonStyle}
        >
          RESTART KYC
        </Button>
      )}

      {kycStatus !== "KYCAPPROVED" &&
        kycStatus !== "SUCCESSFUL" &&
        kycStatus !== "KYCREJECTED" &&
        kycStatus !== "KYCEXPIRED" &&
        kycStatus !== "ESIGNREQUIRED" && (
          <Button
            onClick={() => {
              toast.success("your Kyc is under process");
              navigate("/dashboard");
            }}
            type="submit"
            variant="contained"
            size="medium"
            sx={buttonStyle}
          >
            CHECK STATUS
          </Button>
        )}

      {kycStatus === "KYCAPPROVED" && (
        <Button
          onClick={() => proceed()}
          type="submit"
          variant="contained"
          size="medium"
          sx={buttonStyle}
        >
          PROCEED
        </Button>
      )}
      {/* <Button
        onClick={() => esignAction()}
        type="submit"
        variant="contained"
        size="medium"
        sx={buttonStyle}
      >
        PROCEED TO E-SIGN
      </Button>  */}
    </Grid>
  );
}

const buttonStyle = {
  mt: 3,
  mb: 2,
  py: 1,
  fontFamily: "'Poppins', sans-serif",
  width: {
    xs: "100%",
    sm: "100%",
    md: "40%",
  },
  alignSelf: "center",
  background: process.env.REACT_APP_BUTTON_GRADIENT_COLOR,
};
